<template>
  <div class="team-page">
    <div class="title">
      <van-icon name="arrow-left" class="lefticon" @click="$router.back()" />
      <p>三人成行，享检测九折优惠</p>
    </div>

    <section class="team-card team-hero">
      <div class="team-title">三人成行，享检测九折优惠</div>
      <div class="team-subtitle">
        队伍满3人后，队内成员持续享受优惠价。系统会优先使用VIP价，若未配置VIP价，则自动按原价9折计算。
      </div>
      <div v-if="team" class="team-status">
        <span v-if="team.qualified" class="team-badge success">当前队伍已达标</span>
        <span v-else class="team-badge pending">当前队伍还差{{ remainingCount }}人达标</span>
      </div>
    </section>

    <section class="team-card" v-if="team">
      <div class="team-section-title">队伍信息</div>
      <div class="team-row">
        <span>队长</span>
        <strong>{{ team.captain.nick_name }}</strong>
      </div>
      <div class="team-row">
        <span>人数</span>
        <strong>{{ team.member_count }}/{{ team.max_members }}</strong>
      </div>
      <div class="team-row">
        <span>优惠</span>
        <strong>VIP价优先，未配置则9折</strong>
      </div>
      <div class="team-row" v-if="team.qualified_at">
        <span>达标时间</span>
        <strong>{{ team.qualified_at }}</strong>
      </div>
    </section>

    <section class="team-card" v-if="team && team.members && team.members.length">
      <div class="team-section-title">队员列表</div>
      <div class="team-member" v-for="item in team.members" :key="item.id">
        <div>
          <div class="team-member-name">{{ item.user.nick_name }}</div>
          <div class="team-member-role">{{ item.role === "captain" ? "队长" : "队员" }}</div>
        </div>
        <span class="team-member-time">{{ item.joined_at }}</span>
      </div>
    </section>

    <section class="team-card">
      <div class="team-section-title">邀请链接</div>
      <div class="team-share-box">{{ shareUrl }}</div>
      <div class="team-share-tip">分享仅用于邀请队友加入，优惠依据组队达标发放，不以分享行为本身作为奖励条件。</div>
    </section>

    <section class="team-card" v-if="rules.length">
      <div class="team-section-title">活动说明</div>
      <ol class="team-rules">
        <li v-for="(rule, index) in rules" :key="index">{{ rule }}</li>
      </ol>
    </section>

    <section class="team-card" v-if="!team && !loading">
      <div class="team-empty-title">你当前还没有有效队伍</div>
      <div class="team-empty-desc">可以先发起组队，也可以打开邀请链接加入其他队伍。</div>
    </section>

    <div class="team-actions" v-if="!loading">
      <van-button type="info" block v-if="!team && !token" @click="handleCreateTeam">发起组队</van-button>
      <van-button type="info" block v-if="canJoin" @click="handleJoinTeam">加入队伍</van-button>
      <van-button plain type="info" block v-if="team && team.current_user_joined" @click="copyShareUrl">复制邀请链接</van-button>
      <van-button plain type="primary" block v-if="team && team.current_user_joined" @click="$router.push('/jcsystem')">去下单</van-button>
      <van-button plain type="danger" block v-if="team && team.current_user_joined" @click="handleLeaveTeam">退出队伍</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {
      loading: true,
      token: "",
      team: null,
      rules: [],
      isLogin: false,
    };
  },
  computed: {
    remainingCount() {
      if (!this.team) {
        return 0;
      }

      return Math.max((this.team.required_members || 3) - (this.team.member_count || 0), 0);
    },
    canJoin() {
      return !!(
        this.team &&
        !this.team.current_user_joined &&
        ["open", "full"].includes(this.team.status) &&
        this.team.remaining_slots > 0
      );
    },
    shareUrl() {
      const token = this.team ? this.team.token : this.token;
      return token
        ? `${window.location.origin}/p/team?token=${token}`
        : `${window.location.origin}/p/team`;
    },
  },
  created() {
    this.token = this.$route.query.token || "";
    this.isLogin = !!window.sessionStorage.getItem("Token");
    this.loadTeam();
  },
  methods: {
    ensureTeamActionAuth() {
      this.isLogin = !!window.sessionStorage.getItem("Token");
      if (this.isLogin) {
        return true;
      }

      const redirect = `/team${this.token ? `?token=${this.token}` : ""}`;
      this.$router.push({
        path: "/Login",
        query: {
          redirect,
        },
      });
      return false;
    },
    loadTeam() {
      this.loading = true;
      this.isLogin = !!window.sessionStorage.getItem("Token");
      const request = this.token
        ? this.$http.getTeamByToken(this.token)
        : this.$http.getCurrentTeam();

      request
        .then((res) => {
          this.team = res.team || null;
          this.rules = Array.isArray(res.rules) ? res.rules : [];
          window.sessionStorage.setItem("team_discount_qualified", this.team && this.team.qualified ? "1" : "0");
          if (this.team && this.team.token) {
            this.token = this.team.token;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleCreateTeam() {
      if (!this.ensureTeamActionAuth()) {
        return;
      }

      this.$http.createTeam().then(() => {
        Toast("组队已创建");
        this.loadTeam();
      });
    },
    handleJoinTeam() {
      if (!this.ensureTeamActionAuth()) {
        return;
      }

      if (!this.token) {
        Toast("缺少组队邀请码");
        return;
      }

      this.$http.joinTeam(this.token).then(() => {
        Toast("加入成功");
        this.loadTeam();
      });
    },
    handleLeaveTeam() {
      if (!this.ensureTeamActionAuth()) {
        return;
      }

      Dialog.confirm({
        title: "确认退出",
        message: this.team && this.team.current_user_role === "captain"
          ? "队长退出后当前队伍会关闭，确认继续吗？"
          : "确认退出当前队伍吗？",
      }).then(() => {
        this.$http.leaveTeam().then(() => {
          Toast("已退出");
          this.token = "";
          this.loadTeam();
        });
      }).catch(() => {});
    },
    copyShareUrl() {
      const input = document.createElement("input");
      input.value = this.shareUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      Toast.success("邀请链接已复制");
    },
  },
};
</script>

<style scoped>
.team-page {
  min-height: 100vh;
  background: #f5f7fb;
  padding-bottom: 0.5rem;
}
.title {
  display: flex;
  background: #228ef7;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.4rem;
}
.title p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}
.team-card {
  margin: 0.24rem;
  padding: 0.28rem;
  border-radius: 0.18rem;
  background: #fff;
  box-shadow: 0 0.12rem 0.26rem rgba(15, 23, 42, 0.06);
}
.team-hero {
  background: linear-gradient(135deg, #eff6ff, #ffffff);
}
.team-title {
  font-size: 0.42rem;
  font-weight: 700;
  color: #0f172a;
}
.team-subtitle {
  margin-top: 0.14rem;
  color: #64748b;
  line-height: 1.8;
  font-size: 0.28rem;
}
.team-status {
  margin-top: 0.18rem;
}
.team-badge {
  display: inline-block;
  padding: 0.08rem 0.2rem;
  border-radius: 999px;
  font-size: 0.24rem;
}
.team-badge.success {
  color: #166534;
  background: #dcfce7;
}
.team-badge.pending {
  color: #92400e;
  background: #fef3c7;
}
.team-section-title {
  margin-bottom: 0.2rem;
  font-size: 0.32rem;
  font-weight: 700;
  color: #0f172a;
}
.team-row,
.team-member {
  display: flex;
  justify-content: space-between;
  gap: 0.2rem;
  padding: 0.18rem 0;
  border-bottom: 1px solid #edf2f7;
}
.team-row:last-child,
.team-member:last-child {
  border-bottom: none;
}
.team-row span,
.team-member-role,
.team-member-time {
  color: #64748b;
}
.team-row strong {
  text-align: right;
  color: #0f172a;
}
.team-member-name {
  color: #0f172a;
  font-weight: 700;
}
.team-share-box {
  padding: 0.18rem;
  border-radius: 0.14rem;
  background: #f8fbff;
  border: 1px dashed #cfe0f1;
  color: #475569;
  line-height: 1.8;
  word-break: break-all;
}
.team-share-tip {
  margin-top: 0.14rem;
  color: #64748b;
  line-height: 1.8;
  font-size: 0.24rem;
}
.team-rules {
  margin: 0;
  padding-left: 0.34rem;
  color: #64748b;
  line-height: 2;
}
.team-empty-title {
  font-size: 0.34rem;
  font-weight: 700;
  color: #0f172a;
}
.team-empty-desc {
  margin-top: 0.14rem;
  color: #64748b;
  line-height: 1.8;
}
.team-actions {
  margin: 0.24rem;
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}
</style>
